import { GameServices } from "game/GameServices";
import { Camera, LightingEnvironment, ImageBasedLighting, LightType, Color } from "pixi3d";
import { createCubeMapFromColor, createCubeMap, createLight } from "./3DUtils";

export function setupLightsAndCamera(services: GameServices, spec: any) {
    const camera = Camera.main;
    const lightingEnvironment = LightingEnvironment.main;

    (<any>window).camera = camera;
    (<any>window).lightingEnvironment = lightingEnvironment;

    camera.orthographic = true;
    camera.rotationQuaternion.setEulerAngles(0, 0, 180);

    lightingEnvironment.imageBasedLighting = new ImageBasedLighting(
        createCubeMapFromColor(0.7, 0, 0, 1),
        createCubeMap(services, spec.specularCubemap)
    );

    const color = new Color(1, 0.9, 0, 1);

    const light = createLight(LightType.directional, {intensity: 2, color});
    light.rotationQuaternion.setEulerAngles(95, 0, 0);

    const light1 = createLight(LightType.directional, {intensity: 2, color});
    light1.rotationQuaternion.setEulerAngles(-95, 0, 0);

    const light2 = createLight(LightType.directional, {intensity: 5, color});
    light2.rotationQuaternion.setEulerAngles(0, 0, 0);

    const light3 = createLight(LightType.directional, {intensity: 5, color});
    light3.rotationQuaternion.setEulerAngles(20, 60, 0);

    const light4 = createLight(LightType.directional, {intensity: 5, color});
    light4.rotationQuaternion.setEulerAngles(20, -60, 0);

    lightingEnvironment.lights.push(
        light,
        light1,
        light2,
        light3,
        light4,
    );

    camera.position.set(0);
    camera.rotationQuaternion.setEulerAngles(0, 0, 0);
}